@if (openRound(); as r) {
  <section class="aside-card">
    <p class="aside-eyebrow">Prazo para votar</p>
    <p class="aside-deadline">{{ r.deadlineAt | vaultDateTime }}</p>
    <p class="aside-muted">
      Enviado ao comitê por {{ r.submittedByName }} em {{ r.submittedAt | vaultDateTime }}
    </p>
    @if (r.isOverdue) {
      <div class="aside-box aside-box--danger">
        <strong>Prazo vencido.</strong>
        @if (pendingNames()) {
          Lembrete enviado a {{ pendingNames() }}, e os sócios e o comercial foram avisados do
          atraso.
        }
        O voto continua aberto até o comitê decidir.
      </div>
    } @else {
      <div class="aside-box">
        Quem ainda não votou recebe um lembrete antes do prazo. Se o prazo vencer, os sócios e o
        comercial são avisados do atraso, e o voto continua aberto.
      </div>
    }
  </section>
}

<section class="aside-card">
  <h3 class="aside-title">Regras do comitê</h3>
  <ul class="aside-rules">
    <li>
      {{ majority() }} aprovações aprovam o deal; {{ majority() }} negações negam. Quem falta votar
      não é mais pedido.
    </li>
    <li>Contestação em aberto segura a decisão até o comercial responder.</li>
    <li>Negar exige justificativa; Contestar exige comentário.</li>
    <li>Aprovar e Negar são finais: depois de enviados, não mudam.</li>
    <li>Nada se edita nem se apaga: tudo fica na trilha do deal.</li>
    <li>
      O parceiro só vê o comitê se o deal for negado: aí vê o motivo e as justificativas de quem
      negou.
    </li>
  </ul>
</section>

<section class="aside-card">
  <h3 class="aside-title">Material do comitê</h3>
  <div class="aside-links">
    <app-button
      [label]="'Análise econômica'"
      [icon]="'chart-line'"
      [theme]="'link'"
      [noMargin]="true"
      [type]="'button'"
      (sendButtonClick)="openTab.emit('economic-analysis')" />
    <app-button
      [label]="'Documentos do deal'"
      [icon]="'folder-open'"
      [theme]="'link'"
      [noMargin]="true"
      [type]="'button'"
      (sendButtonClick)="openTab.emit('documents')" />
    <app-button
      [label]="'Linha do tempo'"
      [icon]="'history'"
      [theme]="'link'"
      [noMargin]="true"
      [type]="'button'"
      (sendButtonClick)="openTab.emit('timeline')" />
  </div>
</section>
